<div class="modal-body text-center p-3">
  <!-- <div class="mb-3">
    <i
      class="mdi mdi-information-variant-circle text-warning"
      style="font-size: 2.5rem"
    ></i>
  </div> -->

  <h5 class="fw-bold mb-3">{{ dialogDetails?.title || "Notice" }}</h5>

  <p class="text-muted mb-3" style="font-size: 0.95rem">
    {{ dialogDetails?.confirmationMsg }}
  </p>
  <hr style="margin: 8px !important" />
  <!-- Single action button -->
  <div>
    <button type="button" class="btn btn-primary px-4" (click)="accept()">
      OK
    </button>
  </div>
</div>
